define(function (require) {
    var $ = require('jquery');

    if ($('#stateSelect').length > 0) {
        var $locationBtnSelected = $(".plan-finder-questions .btn.has-selection");
        var $locationBtnUnselected = $(".plan-finder-questions .btn.unselected");

        if ($('#stateSelect').val() === "" || $('#countySelect').val() === "") {
            $locationBtnUnselected.show();
            $locationBtnSelected.hide();
        } else {
            $locationBtnUnselected.hide();
            $locationBtnSelected.show();
        }

        $('#stateSelect').change(function () {
            var stateCode = $('#stateSelect').val();
            if (stateCode.length === 2) {
                $.ajax('/api/planfinderapi/counties?state=' + stateCode).done(function (data) {
                    var json = $.parseJSON(data);
                    $("#countySelect").empty();
                    $.each(json,
                        function (key, value) {
                            var option = value["Value"];
                            var county = value["Text"];
                            $("#countySelect").append("<option value='" + option + "'>" + county + "</option>");
                        });
                    $('#countySelect').selectpicker('refresh');
                    $('#countySelect').focus();
                });
            }
        });
    //    $("#countySelect").on("change", function () {
    //        $("#planFinderForm").submit();
    //    });
    }
});
